import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { faChevronLeft, faWifi } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { routes } from "../../constants";

export const Offline = () => (
	<main>
		<section className="vh-100 d-flex align-items-center justify-content-center">
			<Container>
				<Row className="align-items-center">
					<Col
						xs={12}
						lg={12}
						className="order-2 order-lg-1 text-center"
					>
						<h1 className="text-primary mt-5">
							<FontAwesomeIcon icon={faWifi} className="me-3" />
							Offline
						</h1>
						<p className="lead my-4">
							Oof, looks like you're offline, please refresh this
							page when you get back online.
						</p>
						<Link to={routes.dashboardOverview.path}>
							<Button variant="primary" className="animate-hover">
								<FontAwesomeIcon
									icon={faChevronLeft}
									className="animate-left-3 me-3 ms-2"
								/>
								Go back home
							</Button>
						</Link>
					</Col>
				</Row>
			</Container>
		</section>
	</main>
);
